import type { Prototype } from "../prototype-types";

export const vikasLalwaniPrototypes: Prototype[] = [
  {
    id: "vikas-cart-checkout-ctas",
    name: "Cart Checkout CTAs",
    path: "/vikas/cart-checkout-ctas",
    description:
      "Clearer per-cart checkout actions and a more prominent checkout bar",
    owner: "Vikas Lalwani",
    createdAt: "2026-08-04",
    lastUpdated: "2026-08-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f9cc1c48df13c39a83576346320d71c4ed65727d1d25a34983c0050ddbbaa4ed.png",
    creationTool: "claude-code",
  },
  {
    id: "vikas-instacart-incentive-banner",
    name: "Instacart-style incentive banner",
    path: "/vikas/instacart-incentive-banner",
    description:
      "Tests a high-salience first-order incentive treatment inspired by Instacart.",
    owner: "Vikas Lalwani",
    createdAt: "2026-08-05",
    lastUpdated: "2026-08-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/027afdc9f65f95f7cf23e515e22d5ae1ee0be5c8b1452a12df9efaa2ddddef77.png",
    creationTool: "claude-code",
  },
  {
    id: "vikas-one-banner-to-rule-them-all",
    name: "One banner to rule them all",
    path: "/vikas/one-banner-to-rule-them-all",
    description:
      "A persistent, benefit-led home for Faire programs and retailer growth tools.",
    owner: "Vikas Lalwani",
    createdAt: "2026-08-05",
    lastUpdated: "2026-08-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/059fea3402cd27a1d21cd081817edf4f9af7c92e9fa4343db0d2a17af793afac.png",
    creationTool: "claude-code",
  },
];
